import styled, { keyframes } from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import AtLogoDesk from "../../assets/at-logo.svg";

interface DeskLogoProps {
  $isScrolled: boolean;
}

const ATLogoBurger = styled.img<DeskLogoProps>`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    align-self: flex-start;
    width: ${(props) => (props.$isScrolled ? "50px" : "80px")};
    margin: 24px 10px;
    transition: width 0.3s ease;
  }
`;

// Logo and navigation to startpage
interface AtDeskLogoProps {
  $isScrolled: boolean;
  style?: React.CSSProperties;
}

export const AtLogoDesktop: React.FC<AtDeskLogoProps> = ({ $isScrolled }) => {
  const navigate = useNavigate();

  const scrollToTop = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };
  return (
    <Link to="/" onClick={scrollToTop}>
      <ATLogoBurger
        src={AtLogoDesk}
        alt="Andtech logo"
        $isScrolled={$isScrolled}
      />
    </Link>
  );
};

export const DesktopMenuContainer = styled.div`
  display: none;

  /* Desktop */
  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 20px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
    transition: background-color 0.3s ease;
  }
`;

export const DesktopLinkContainer = styled.div`
  display: none;

  /* Desktop */
  @media (min-width: 1024px) {
    display: flex;
    margin-right: 50px;
    gap: 45px;
  }
`;

interface LinkLineProps {
  to?: string;
}

export const DeskMenuLinks = styled(Link)<LinkLineProps>`
  display: none;

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 17px;
    letter-spacing: 0.8px;
    font-weight: 500;
    position: relative;
    color: var(--maindark);
    text-decoration: none;
    text-transform: uppercase;
    display: inline-block;
    padding-top: 5px;
    margin: 5px 0;
  }

  &:hover {
    color: var(--accent);
  }

  &:hover::after {
    width: 100%;
  }
`;

const linkWave = keyframes`
  0%, 100% { 
    transform: translateY(0); 
    color: var(--maindark);
  }
  50% { 
    transform: translateY(-8px);
    color: var(--accent);
  }
`;

export const DeskMenuWavyLinks = styled(Link)<LinkLineProps>`
  display: none;

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 17px;
    letter-spacing: 0.8px;
    font-weight: 500;
    position: relative;
    color: var(--maindark);
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 2px;
    display: inline-block;
    padding-top: 5px;
    margin: 5px 0;
  }

  &:hover {
    color: var(--accent);
  }

  &:hover span {
    animation: ${linkWave} 0.6s ease-in-out forwards;
  }
`;

const Letter = styled.span`
  display: inline-block;
`;

export const AniDeskMenuLink = ({
  to,
  children,
}: LinkLineProps & { children: string }) => {
  return (
    <DeskMenuWavyLinks to={to}>
      {children.split("").map((letter, i) => (
        <Letter key={i} style={{ animationDelay: `${i * 0.05}s` }}>
          {letter === " " ? "\u00A0" : letter}
        </Letter>
      ))}
    </DeskMenuWavyLinks>
  );
};
